import httpbaseURL from "../common/axios";
class Commonservices {
  Create(doc) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.post(
      "/ModuleMaster/Create",
      doc
    );
  }
  List() {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.get("/ModuleMaster/List");
  }
  Edit(Id) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.get(
      "/ModuleMaster/Get?id=" + Id
    );
  }
  Update(doc) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.post(
      "/ModuleMaster/Update",
      doc
    );
  }
  Delete(Id) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.delete(
      "/ModuleMaster/Delete?ID=" + Id
    );
  }

  GetModulesByOrganizationId(OrganizationId) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.get(
      "/ModuleMaster/GetModulesByOrganizationId?OrganizationId=" +
        OrganizationId
    );
  }
}
export default new Commonservices();
